import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { Button } from '../../../elementals';
import { TextAreaField } from '../../../formFields';
const BUTTON_LABEL = 'Edit Additional Notes';
const additionalNotesField = ({ elmId, error, readOnly, touched, value, onChange, onBlur, onFocus, }) => {
    const [isEditable, setIsEditable] = useState(false);
    useEffect(() => {
        if (readOnly) {
            setIsEditable(false);
        }
    }, [readOnly]);
    const handleEditable = useCallback(() => {
        setIsEditable(true);
    }, []);
    return isEditable ? (_jsx(TextAreaField, { style: { resize: 'vertical' }, className: 'u-mb-2', elmId: elmId, error: error, value: value, placeholder: 'Enter additional notes', maxLength: '512', onChange: onChange, onBlur: onBlur, onFocus: onFocus, rows: 5, touched: touched, disabled: readOnly })) : (_jsx(Button, { role: 'secondary', onClick: handleEditable, disabled: readOnly, title: BUTTON_LABEL, children: BUTTON_LABEL }));
};
export default additionalNotesField;
//# sourceMappingURL=additionalNotesField.js.map